import {Spin} from "antd";
import {StyledPendingPayoutBox} from "./style";
import {UseQueryResult} from "@tanstack/react-query";
import {TConnectedBankApiResponse} from "../../../../../../../react-query-hooks/payout";
import {numberWithCommas} from "../../../../../../../services/helpers";

export function PendingPayout({
  isPendingPayoutOrConnectedBankError,
  isPendingPayoutOrConnectedBankLoading,
  isPendingPayoutOrConnectedBankFetching,
  connectedBankData,
  pendingPayoutData,
}: {
  isPendingPayoutOrConnectedBankError: boolean;
  isPendingPayoutOrConnectedBankLoading: boolean;
  isPendingPayoutOrConnectedBankFetching: boolean;
  connectedBankData: UseQueryResult<TConnectedBankApiResponse>;
  pendingPayoutData: UseQueryResult<{
    pendingPayouts: number;
  }>;
}) {
  return (
    <StyledPendingPayoutBox>
      <Spin
        spinning={
          isPendingPayoutOrConnectedBankLoading || isPendingPayoutOrConnectedBankFetching
        }
        style={{width: "100%"}}
      >
        <div className="text-content">
          <p className="heading-text">Pending payout</p>
          {isPendingPayoutOrConnectedBankError ? (
            <p className="value-text">0</p>
          ) : pendingPayoutData.isSuccess && connectedBankData.isSuccess ? (
            <p className="value-text">
              {connectedBankData.data.bank.currency}{" "}
              {numberWithCommas(
                Math.round(Number(pendingPayoutData.data.pendingPayouts))
              )}
            </p>
          ) : null}
        </div>
      </Spin>
    </StyledPendingPayoutBox>
  );
}
